<div
  class="device-info-container columns is-multiline is-gapless is-hidden-mobile"
  id="{{isDeviceBeingCompared ? 'beingCompared': 'scrollToOnAddDevice'}}"
>
  <div class="column is-two-fifths">
    <img
      class="device-image"
      src="{{ device.imageLocation }}"
      [attr.alt]="device.productDescShort"
    />
  </div>
  <div class="column is-three-fifths">
    <div class="device-title-container">
      <label class="device-title">{{ device.productDescShort }}</label>
    </div>
    <div class="spacer-small"></div>
    <!-- <div>
      <label class="device-info-header">{{ specsHeader }}</label>
    </div> -->
    <table>
      <tr>
        <td class="info-label">{{ processorLabel }}<span class="info-text">{{ device.cpuModel }}</span></td>
      </tr>
      <div class="spacer-xx-small"></div>
      <tr>
        <td class="info-label">{{ memoryLabel }} <span class="info-text">{{ device.memorySize }} {{ device.memoryUnit }}</span></td>
      </tr>
      <div class="spacer-xx-small"></div>
      <tr>
        <td class="info-label">{{ storageLabel }} <span class="info-text">          {{ device.diskDriveSize }} {{ device.diskDriveUnit }}
          {{ device.diskDriveType }}</span></td>
      </tr>
      <div class="spacer-xx-small"></div>
      <tr>
        <td class="info-label">{{ displayLabel }} <span class="info-text">{{ device.screenSize }}</span></td>
      </tr>
    </table>
    <div class="spacer-small"></div>
    <div  *ngIf="showInStockInfo" >
      <p class="info-label stock" [ngClass]="{'in-stock': device.isInStock, 'out-stock': !device.isInStock}">{{device.isInStock ? 'In Stock' : 'Out of Stock'}}</p>
    </div>
    <!-- <div>
      <label class="device-info-header">{{ descriptionHeader }}</label>
    </div>
    <p class="device-desc">
      {{ device.productDescLong }}
    </p> -->
    <!-- <div class="buffer-medium"></div> -->
    <div class="columns learn-more-wrapper">
      <div class="column is-half">
        <button
        *ngIf="showLearnMoreButton"
          tabindex="0"
          class="learn-more-button"
          (click)="learnMoreBtnClick(device)"
          [attr.aria-label]="learnMoreScreenReaderText"
        >
          <span aria-hidden="true">{{ learnMoreButtonText }}</span>
        </button>
        <div class="compare-wrapper">
        <mat-checkbox
        class="result-filter-cb compare-checkbox"
        tabindex="0"
        [checked]="isDeviceBeingCompared"
        (change)="compareDevice(device)"
        [disabled]="!isDeviceBeingCompared && checkboxesAreDisabled"></mat-checkbox>
        <label class="compare-label device-desc">Compare</label>
        </div>
      </div>
      <div class="column" id="addToCartClick" *ngIf="showAddToCartButton">
        <form>
        <button
          *ngIf="showAddToCartButton"
          mat-flat-button
          class="secondary"
          (click)="addToCartClick(device, itemQuantity.value)" type="submit"
        >ADD TO CART</button>
        <label style="margin-left: 10px;">QTY: </label>
        <input matInput id="itemQuantityInput" placeholder="1" value="1" type="number" min="1" max="99999" appearance="fill" #itemQuantity required>
        <h3 name="formQuantityError">{{formQuantityError}}</h3>
        </form>
      </div>
    </div>
    <label *ngIf="showIncludeLicenseCheckbox">Include Chrome Enterprise License Upgrade</label>
    <!-- <br/> -->
    <mat-radio-group [(ngModel)]="subscriptionChoice" *ngIf="showIncludeLicenseCheckbox">
      <mat-radio-button *ngFor="let data of subscriptionList" [name]="data.name" [value]="data.value">{{data.name}}</mat-radio-button>
    </mat-radio-group>
  </div>
</div>
<div
  class="device-info-container columns is-multiline is-mobile is-gapless is-hidden-tablet"
>
  <div class="column img-mobile-device" (click)="learnMoreBtnClick(device)">
    <img
      class="device-image"
      src="{{ device.imageLocation }}"
      [attr.alt]="device.productDescShort"
    />
  </div>
  <div class="column info-mobile-device" (click)="learnMoreBtnClick(device)">
    <div class="device-title-container">
      <label class="device-title">{{ device.productDescShort }}</label>
    </div>
    <table>
      <tr>
        <td class="info-label">{{ processorLabel }}<span class="info-text">{{ device.cpuModel }}</span></td>
      </tr>
      <div class="spacer-xx-small"></div>
      <tr>
        <td class="info-label">{{ memoryLabel }} <span class="info-text">{{ device.memorySize }} {{ device.memoryUnit }}</span></td>
      </tr>
      <div class="spacer-xx-small"></div>
      <tr>
        <td class="info-label">{{ storageLabel }} <span class="info-text">          {{ device.diskDriveSize }} {{ device.diskDriveUnit }}
          {{ device.diskDriveType }}</span></td>
      </tr>
      <div class="spacer-xx-small"></div>
      <tr>
        <td class="info-label">{{ displayLabel }} <span class="info-text">{{ device.screenSize }}</span></td>
      </tr>
    </table>
    <div class="spacer-x-small"></div>
    <div  *ngIf="showInStockInfo" >
      <p class="info-label stock" [ngClass]="{'in-stock': device.isInStock, 'out-stock': !device.isInStock}">{{device.isInStock ? 'In Stock' : 'Out of Stock'}}</p>
    </div>
    <div class="spacer-x-small"></div>
    <div *ngIf="showLearnMoreButton" class="columns learn-more-wrapper learn-more-wrapper-mobile">
        <button
          tabindex="0"
          class="learn-more-button"
          (click)="learnMoreBtnClick(device)"
          [attr.aria-label]="learnMoreScreenReaderText"
        >
          <span aria-hidden="true">{{ learnMoreButtonText }}</span>
        </button>

     <div class="column" id="addToCartClick" *ngIf="showAddToCartButton">
      <form>
      <button
        *ngIf="showAddToCartButton"
        mat-flat-button
        class="secondary"
        (click)="addToCartClick(device, itemQuantity.value)" type="submit"
      >ADD TO CART</button>
      <label style="margin-left: 10px;">QTY: </label>
      <input matInput id="itemQuantityInput" placeholder="1" value="1" type="number" min="1" max="99999" appearance="fill" #itemQuantity required>
      <h3 name="formQuantityError">{{formQuantityError}}</h3>
      </form>
    </div>
  </div>
  <label *ngIf="showIncludeLicenseCheckbox">Include Chrome Enterprise License Upgrade</label>
  <!-- <br/> -->
  <mat-radio-group [(ngModel)]="subscriptionChoice" *ngIf="showIncludeLicenseCheckbox">
    <mat-radio-button *ngFor="let data of subscriptionList" [name]="data.name" [value]="data.value">{{data.name}}</mat-radio-button>
  </mat-radio-group>
</div>
  <!-- <div class="column">
    <div
      class="mobile-device-detail-container"
      [ngClass]="{ 'include-border': includeBottomBorderMobile }"
    >
      <mat-accordion>
        <mat-expansion-panel>
          <mat-expansion-panel-header>
            <mat-panel-title>
              {{ additionalDetailsHeader }}
            </mat-panel-title>
            <mat-panel-description> </mat-panel-description>
          </mat-expansion-panel-header>
          <div>
            <div>
              <div class="buffer-medium"></div>
              <div class="info-label">
                {{ processorLabel }}
              </div>
              <div class="info-text">
                {{ device.cpuModel }}
              </div>
              <div class="buffer-small"></div>
            </div>
            <div>
              <div class="info-label">
                {{ memoryLabel }}
              </div>
              <div class="info-text">
                {{ device.memorySize }} {{ device.memoryUnit }}
              </div>
              <div class="buffer-small"></div>
            </div>
            <div>
              <div class="info-label">
                {{ storageLabel }}
              </div>
              <div class="info-text">
                {{ device.diskDriveSize }} {{ device.diskDriveUnit }}
                {{ device.diskDriveType }}
              </div>
              <div class="buffer-small"></div>
            </div>
            <div>
              <div class="info-label">
                {{ displayLabel }}
              </div>
              <div class="info-text">
                {{ device.screenSize }}
              </div>
              <div class="buffer-small"></div>
            </div>
            <div>
              <div class="info-label">
                {{ formFactorsLabel }}
              </div>
              <div class="info-text">
                {{ device.productType }}
              </div>
              <div class="buffer-small"></div>
            </div>
            <div>
              <div class="info-label">
                {{ osTypeLabel }}
              </div>
              <div class="info-text">
                {{ device.osType }}
              </div>
              <div class="buffer-small"></div>
            </div>
            <div>
              <div class="info-label">
                {{ additionalFeaturesLabel }}
              </div>
              <div class="info-text">
                {{ device.productDescLong }}
              </div>
              <div class="buffer-medium"></div>
            </div>
          </div>
        </mat-expansion-panel>
      </mat-accordion>
    </div>
  </div> -->
</div>
